import React, { useEffect, useRef } from "react";
import { RxCross2 } from "react-icons/rx";

const CreativeDialog = ({ isOpen, onClose, content, title, setReassignedCreativeItem }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        onClose();
        setReassignedCreativeItem(null);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-10 bg-black bg-opacity-50 transition-opacity duration-500 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <div
        ref={dialogRef}
        className={`bg-white rounded-lg shadow-lg  w-[550px] transform transition-transform duration-500 ${
          isOpen ? "scale-100" : "scale-90"
        }`}
      >
        <div className="flex px-4 py-3  justify-between rounded-t-lg bg-[#EAEAEA] items-center">
          <h2 className="popupHead">{title}</h2>
          <button
            onClick={() => (onClose() , setReassignedCreativeItem(null))}
            className="text-gray-500 cursor-pointer hover:text-gray-800"
          >
            <RxCross2 className="text-lg" />
          </button>
        </div>
        <div className="p-4">{content}</div>
      </div>
    </div>
  );
};

export default CreativeDialog;
